import { memo } from "react";
import { useUser } from "../../hooks/User";
import PublicHeader from "./publicHeader";
import { PrivateHeader } from "./privateHeader";
import "./header.scss";

const HeaderComponent = () => {

  const isLogged = useUser().getDataByAttributeName("isLogged");

  if (!isLogged)
    return <PublicHeader />;
  else
    return <PrivateHeader />
};

export const Header = memo(HeaderComponent);
